module.exports = __webpack_public_path__ + "img/live.cb4bcefc.svg";